
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import Contact from "./Pages/Contact";
import { useEffect } from "react";
import WOW from 'wow.js'
import "animate.css";


function App() {
    useEffect(() => {
    const wow = new WOW({
    mobile: true,
    live: true,
      });
      wow.init();
    }, []);


  return (
  <div className="App">
  <BrowserRouter>
    <Navbar />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      {/* other routes */}
    </Routes>
  </BrowserRouter>
</div>

  );
}

export default App;
